export enum VoucherModalStateEnum {
  COMPLETE = 'complete',
  INFO = 'info',
  NONE = 'no-modal'
}
